import Box from "@mui/material/Box";
import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import { USERS_URL } from "../../../Constants/Constants";
import AxiosInstance from "../../../services/AxiosInstance";
import AppTableView from "../../AppTableView";
import UserDialog from "./UserDialog";
import UserInfoDialog from "./UserInfo/UserInfoDialog";

function Users() {

  const [data, setData] = useState([]);

  useEffect(() => {
    getUsers();
  }, []);


  const getUsers = () => {
    // TODO: server side pagination isn't implemented in server yet, so this will be currently client side pagination
    AxiosInstance.get(USERS_URL).then((response) => setData(response.data.data));
  };


  return (
    <Container fluid style={{ display: "flex", flexDirection: "column" }}>
      <Box>
        <UserDialog editUserId={""} selectedUserId={""} callUsers={getUsers} isEdit={false} />
      </Box>
      <AppTableView
        rows={data}
        cols={[
          {
            field: "loginId",
            headerName: "Login ID",
            flex: 1,
            renderCell: (params) => (
              <UserDialog
                editUserId={params.row.id}
                selectedUserId={params.row.id}
                callUsers={getUsers}
                isEdit={true}
              />
            ),
          },
          { field: "name", headerName: "Name", flex: 1 },
          { field: "email", headerName: "Email", flex: 1 },
          {
            field: "active",
            headerName: "Status",
            flex: 1,
            renderCell: (params) => (
              <span>{params.value ? "Active" : "Inactive"}</span>
            ),
          },
          // { field: "organizationTitle.name", headerName: "Title", flex: 1 },
          { field: "empId", headerName: "Emp ID", flex: 1 },
          {
            field: "info",
            headerName: "Info",
            flex: 1,
            renderCell: (params) => (
              <UserInfoDialog
                editUserId={params.row.id}
                selectedUserName={params.row.name}
              />
            ),
          },
        ]}
        initialPageSize={15}
      />
    </Container>
  );
}
//https://mui.com/material-ui/react-table/#custom-pagination-actions
export default Users;
